import { name, version } from '../package.json';

export default {
    clearIconAriaLabel: {
        type: String,
        default: 'Clear search field',
        docs: {
            validation: '—',
            description: 'Sets the `aria-label` on the icon-only clear button.',
        },
    },
    disabled: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, sets the `disabled` attribute.',
        },
    },
    label: {
        type: String,
        default: 'Search',
        docs: {
            validation: '—',
            description: 'Sets the `aria-label` for the search field.',
        },
    },
    onDark: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, changes component to on-dark styling.',
        },
    },
    placeholder: {
        type: String,
        default: 'Search...',
        docs: {
            validation: '—',
            description: 'Sets the placeholder text for the select.',
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `small`, `medium`, `large`, `touch`',
            description: 'Sets the size of the search field.',
        },
    },
    value: {
        type: String,
        default: '',
        docs: {
            validation: '—',
            description: 'Sets the `value` attribute of the search field',
            support: ['v-model'],
        },
    },
    variation: {
        type: String,
        default: 'primary',
        validator(value) {
            return ['primary', 'secondary', 'input'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of `primary`, `secondary`, `input`.',
            description: 'Set variation',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
    },
};
